import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { VesselServiceViewStore } from '../../Stores/VesselServiceViewStore'

interface IProps {
  viewStore: VesselServiceViewStore
}

export const VesselServiceHeader: FC<IProps> = observer(({ viewStore }) => {
  const { t } = useTranslate()
  const title = t('vesselService', 'Vessel services')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      breadcrumbs={breadcrumbs}
      rightRenderOption={
        <Button
          variant='contained'
          sx={{ flex: 'none' }}
          onClick={() => {
            viewStore.toggleFormDialog(true)
          }}
        >
          {t('addNew', 'Add new')}
        </Button>
      }
    />
  )
})
